import React, { useState, useEffect } from 'react';
import { Doughnut } from 'react-chartjs-2';
import { Chart as ChartJS, ArcElement, Tooltip, Legend } from 'chart.js';
import useAuthenticatedData from '../hooks/useAuthenticatedData';
import { type } from '@testing-library/user-event/dist/type';

import SalesBacklogChart from './SalesBacklogChart';

import SalesRevenueGoal from './SalesRevenueGoal';
import RepairsBacklogChart from './RepairsBacklogChart';
import RepairsSpendGoal from './RepairsSpendGoal';
import PurchasingSpendGoal from './PurchasingSpendGoal';
import PurchasingBacklogChart from './PurchasingBacklogChart';

const SCSplit = () => {
  const [key, setKey] = useState(0);

  useEffect(() => {
    const interval = setInterval(() => {
      setKey(prevKey => prevKey + 1); // Increment key to force remount
    }, 60000); // Update every minute

    return () => clearInterval(interval); // Clean up the interval
  }, []);

  return (
    <div key={key}>  
      <div className="quadrant-container">
        <SalesBacklogChart />
        <SalesRevenueGoal />
        <div className="sub-quadrant-container">
          <RepairsBacklogChart />
          <RepairsSpendGoal />
        </div>
        <div className="sub-quadrant-container">
          <PurchasingBacklogChart />
          <PurchasingSpendGoal />
        </div>
      </div>
    </div>
  );
}

export default SCSplit;